import moonIcon from '../../assets/icons/moon.svg';
import sunIcon from '../../assets/icons/sun.svg';
import lightningIcon from '../../assets/icons/lightning.svg';
import starIcon from '../../assets/icons/star.svg';
import { CreditPackageType } from '../../domain/Payment';

export const getIcon = (creditPackageType: CreditPackageType) => {
  switch (creditPackageType) {
    case CreditPackageType.BASE:
      return moonIcon;
    case CreditPackageType.OPTIMAL:
      return sunIcon;
    case CreditPackageType.EXPERIENCED:
      return lightningIcon;
    case CreditPackageType.PROFESSIONAL:
      return starIcon;
  }
};
